<template>
  <footer class="row row-space-between site-footer">
    <div class="column copy">
      <p class="mb-1">&copy; Copyright {{ year }} or whatever</p>
    </div>
    <div class="column lg-only">
      <p class="tag-list mb-0">
        <span class="tag">Forever Curious</span>
        <span class="tag">•</span>
        <span class="tag">Always Honest</span>
      </p>
    </div>
  </footer>
</template>
<script setup>
const date = new Date();
const year = date.getFullYear();
</script>
<style lang="scss" scoped>
.highlight {
  color: white;
}
footer.site-footer {
  font-family: "Departure Mono";
  font-size: 1.25rem;
  text-transform: uppercase;
  letter-spacing: 0.2em;
  background: var(--color-page-initial);

  .tag-list {
    gap: 0.5rem;
    .tag {
      font-size: 1.25rem;
    }
  }

  @media (min-width: 40rem) {
    border-top: 1px solid var(--color-border-light);
  }

  a {
    color: var(--color-accent);
    text-decoration: none;
    &:hover {
      color: var(--color-primary);
    }
  }

  .socials a {
    margin-left: 1em;

    &:first-child {
      margin-left: 0;
    }
  }
}
@media (min-width: 40rem) {
  .page-intro {
    margin: 1rem 0;
  }
  footer.site-footer {
    width: var(--sidebar-width);
    .copy {
      display: flex;
    }
  }
}
@media (max-width: 40rem) {
  footer.site-footer {
    margin-bottom: 1rem;
    border-top: 1px solid var(--color-border-light);
  }
}
</style>
